import { userReducer, UserState, initialState } from './UserReducer';
import { UserActions, UserActionTypes } from './UserActions';
import { UserStatePersistenceService } from '../../service/user-state-persistence.service';

export const createUserReducerWithPersistence = (
  persistenceService: UserStatePersistenceService,
) => {
  return (state: UserState | undefined, action: UserActions): UserState => {
    if (state === undefined) {
      const persistedState = persistenceService.loadState();
      if (persistedState.isAuthenticated) {
        state = persistedState;
      } else {
        state = initialState;
      }
    }

    const nextState = userReducer(state, action);

    switch (action.type) {
      case UserActionTypes.InitUser:
      case UserActionTypes.SelectAccount:
      case UserActionTypes.DeSelectAccount:
      case UserActionTypes.SetCsrfToken:
        persistenceService.saveState(nextState);
        break;

      case UserActionTypes.HydrateState:
        break;

      case UserActionTypes.Logout:
      case UserActionTypes.ClearCsrfToken:
        persistenceService.clearState();
        break;

      default:
        if (nextState.isAuthenticated) {
          persistenceService.saveState(nextState);
        }
        break;
    }

    return nextState;
  };
};
